import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";

import { Cell } from "./components/Cell";

import styles from "./Table.module.scss";

const Table = ({
  className,
  headerClassName,
  headerCellClassName,
  headerTextClassName,
  headerTextProps,
  innerClassName,
  rowClassName,
  cellClassName,
  data,
  sticky = true,
  columns,
  cellRenderer,
  onRowClick,
}: any) => (
  <div className={cn(styles.tableWrapper)}>
    <div className={cn(styles.table, className)}>
      <div className={cn(styles.header, headerClassName)}>
        {columns.map((column, index) => (
          <div
            key={column.key}
            className={cn(
              styles.cell,
              styles.headerCell,
              {
                [styles.headerCellActive]: column.highlighted,
                [styles.stickyCell]: sticky && index === 0,
              },
              headerCellClassName
            )}
            style={{
              minWidth: column.minWidth || "70px",
              maxWidth: column.maxWidth || "400px",
              justifyContent: column.justifyContent,
            }}
          >
            <Typography
              variant="h4"
              className={cn(styles.headerText, headerTextClassName)}
              {...headerTextProps}
            >
              {column.label}
            </Typography>
          </div>
        ))}
      </div>
      <div className={cn(styles.body, innerClassName)}>
        {data.map((item, itemIndex) => {
          return (
            <div
              key={item.id}
              className={cn(styles.row, item.rowClassName, rowClassName)}
              onClick={() => onRowClick && onRowClick(item)}
            >
              {columns.map((column, index) =>
                cellRenderer ? (
                  cellRenderer(
                    {
                      ...column,
                      item,
                      itemIndex,
                      className: cn(
                        styles.cell,
                        { [styles.stickyCell]: sticky && index === 0 }, // Sticky for the first column
                        cellClassName
                      ),
                      style: {
                        minWidth: column.minWidth || "70px",
                        maxWidth: column.maxWidth || "400px",
                        justifyContent: column.justifyContent,
                      },
                    },
                    Cell
                  )
                ) : (
                  <Cell
                    minWidth={column.minWidth}
                    maxWidth={column.maxWidth}
                    justifyContent={column.justifyContent}
                    key={column.key}
                    className={cn({
                      [styles.stickyCell]: sticky && index === 0,
                    }, cellClassName)}
                    style={{
                      minWidth: column.minWidth || "70px",
                      maxWidth: column.maxWidth || "400px",
                      justifyContent: column.justifyContent,
                    }}
                  >
                    {item[column.key]}
                  </Cell>
                )
              )}
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default Table;
